import { render, staticRenderFns } from "./yinsiPage.vue?vue&type=template&id=535a0ed2&scoped=true&"
import script from "./yinsiPage.vue?vue&type=script&lang=js&"
export * from "./yinsiPage.vue?vue&type=script&lang=js&"
import style0 from "./yinsiPage.vue?vue&type=style&index=0&id=535a0ed2&lang=scss&scoped=true&"
import style1 from "./yinsiPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535a0ed2",
  null
  
)

export default component.exports